import {
  Ellipsis,
  TypographyColors,
  TypographyVariants,
  Typography
} from "@certa/catalyst/components/Typography";
import type { BreadcrumbCurrentProps } from "../Breadcrumb.types";
import styles from "./BreadcrumbCurrent.module.css";
import { forwardRef } from "react";
import { CatalystColors } from "@certa/catalyst/constants/styles";

const BreadcrumbCurrent = forwardRef<HTMLLIElement, BreadcrumbCurrentProps>(
  ({ link, maxWidth }, ref) => {
    const { label } = link;

    return (
      <li
        className={styles.container}
        ref={ref}
        style={
          maxWidth
            ? {
                maxWidth,
                flexGrow: 0,
                flexBasis: "auto"
              }
            : undefined
        }
      >
        {!!link.leftIcon &&
          link.leftIcon({
            color: CatalystColors.NEUTRAL_700,
            size: 16,
            className: styles.leftIcon
          })}
        <Typography
          color={TypographyColors.NEUTRAL_800}
          variant={TypographyVariants.LABEL_SM_BOLD}
          as="span"
          className="overflow-hidden"
        >
          <Ellipsis>{label}</Ellipsis>
        </Typography>
      </li>
    );
  }
);

export { BreadcrumbCurrent };
